<script setup>

import { ref, onMounted } from "vue";
import ERP from "../../api/v2/ERP.mjs";
import View from "../../api/v2/View.mjs";
import CriarEmail from "./CriarEmail/CriarEmailModal.vue";
import useUsuarioStore from "../../api/v2/stores/UsuarioStore.js";
import useColaboradorStore from "../../api/v2/stores/ColaboradorStore.js";

import { runAction } from "../../services/actionService.js";

import pdfMake from "pdfmake/build/pdfmake.js";
import pdfFonts from "pdfmake/build/vfs_fonts.js";

pdfMake.vfs = pdfFonts.pdfMake.vfs;


//==================================================================//
//=========================== User Store ===========================//
//==================================================================//

const usuarioStore = useUsuarioStore();

//==================================================================//
//======================== Colaborador Store =======================//
//==================================================================//

const colaboradorStore = useColaboradorStore(); 

//==================================================================//
//======================= Campos de Controle =======================//
//==================================================================//

const controlesDesativados = ref(false);
const criandoEmail = ref(false);

//==================================================================//
//======================== Pedido de Compra ========================//
//==================================================================//

const pedidosDeCompra = ref([]);
const pedidoDeCompraLoading = ref(true);
const pedidoDeCompraSelecionado = ref({});

//==================================================================//
//======================== Campos de Busca =========================//
//==================================================================//

const buscaGeral = ref("");

//==================================================================//
//==================== Pedidos de Compra Header ====================//
//==================================================================//

let pedidoDeCompraHeaders = [
    { text: '',                value: 'visualizar',                class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: '',                value: 'pdf',                       class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'N° do Pedido',    value: 'codigo',                    class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Fornecedor',      value: 'fornecedor.nome',           class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Vendedor(a)',     value: 'fornecedorVendedor.nome',   class:"c-pedido__header",    cellClass:'c-pedido__cell'},
]

//==================================================================//
//===================== Load Pedidos de Compra  ====================//
//==================================================================//

const loadPedidosDeCompra = async () =>{

    pedidoDeCompraLoading.value = true;

    const pedidosDeCompraResponse = await ERP.getManyWithView(View.PEDIDO_DE_COMPRA_ENVIAR_PEDIDO,[
        {
            name: "owner",
            dataType: "String",
            value: usuarioStore.usuario.id
        },
    ]);

    pedidosDeCompra.value = pedidosDeCompraResponse.data;

    clearBuscaGeral();

    pedidoDeCompraLoading.value = false;

};

//==================================================================//
//======================== Fill Buscadores =========================//
//==================================================================//

const clearBuscaGeral = () =>{
    buscaGeral.value = "";
};

//==================================================================//
//=========================== Clamp Valor ==========================//
//==================================================================//

const clampValor = (valor,min,max) =>{

    return Math.min(Math.max(valor, min), max);

};

//==================================================================//
//=================== Valor Monetario Formatado ====================//
//==================================================================//

const valorMonetarioFormatado = (valor = 0)=>{

    return new Intl.NumberFormat('default', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(clampValor(valor,-999999999,999999999));

};

//==================================================================//
//================ Altera Visualizacao do Pedido ===================//
//==================================================================//

const alteraCriandoEmail = (update)=>{

    criandoEmail.value = update.criandoEmail;
    pedidoDeCompraSelecionado.value = update?.pedidoDeCompra || {};

    if(criandoEmail.value == false){
        loadPedidosDeCompra();
    }


};

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    controlesDesativados.value = update.controlesDesativados;

};

//==================================================================//
//================ Ao Visualizar Pedido de Compra ==================//
//==================================================================//

const aoVisualizarPedidoDeCompra = (item)=>{

    alteraCriandoEmail({
        criandoEmail: true,
        pedidoDeCompra: item
    });

}

//==================================================================//
//============================ onMounted ===========================//
//==================================================================//

onMounted(async ()=>{

   await loadPedidosDeCompra();

});

//==================================================================//
//===================== Download PDF do Pedido =====================//
//==================================================================//

const getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob); 
        reader.onloadend = () => {
        const base64data = reader.result;   
        resolve(base64data);
        //console.log('base64data: ', base64data)
        }
    });
};

const downloadPDFDoPedido = async (id) =>{

    let pdfResponse = await runAction({name:"PDF Pedido de Compra"},{
        id: id,
    });

    if(pdfResponse?.data?.content[0]?.image){
        const url = pdfResponse?.data?.content[0]?.image;
        const url64 = await getBase64FromUrl(url?.toString())
        pdfResponse.data.content[0].image = url64
    }

    if(pdfResponse.footer){
        let columns = pdfResponse.footer;
        console.log("COLUMNS >>> ", columns)

        pdfResponse.data.footer = function(currentPage, pageCount) { //currentPage, pageCount
            // this.result.currentPage = currentPage
            // this.result.pageCount = pageCount

            return JSON.parse(JSON.stringify(columns));

        }
    }

    if(pdfResponse.header){
        pdfResponse.data.header = pdfResponse.header;
    }

    console.log(pdfResponse);

    let teste = pdfMake.createPdf(pdfResponse.data).download("PDF Pedido de Compra");

    console.log(teste);

};

</script>

<template>

    <main 
        class="c-main"
        :class="{ 'c-main--disabled': controlesDesativados }"
    >

        <h2>
            Pedidos para Enviar
        </h2>

        <v-card>

            <v-card-title
                class="c-pedido-holder"
            >

                <h3
                    class="c-pedido__titulo"
                >
                    Pedidos de Compra
                </h3>

                <div
                    class="c-pedido__buscas"
                >

                    <v-text-field
                        label="Buscar"
                        class="c-busca__geral"
                        v-model="buscaGeral"
                        append-icon="mdi-magnify"
                        single-line
                        hide-details
                        outlined
                        clearable
                        :disabled="controlesDesativados"
                    >
                    </v-text-field>

                </div>

                <v-chip
                    class="c-comprador"
                    label
                >

                    <v-icon left>
                        mdi-account-circle-outline
                    </v-icon>
                    Comprador:
                    {{colaboradorStore.colaborador.nome}}

                </v-chip>

            </v-card-title>

            <v-data-table
                class="c-pedido__tabela elevation-1"
                :headers="pedidoDeCompraHeaders"
                :items="pedidosDeCompra"
                :search="buscaGeral"
                :items-per-page="-1"
                select-strategy="all"
                item-key="id"
                return-object
                :loading="pedidoDeCompraLoading"
                loading-text="Carregando... Por favor, aguarde."
            >

                <template v-slot:item.visualizar="{ item }">

                    <v-tooltip bottom>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                class="c-visualizar-pedido mx-2"
                                fab
                                dark
                                small
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                                :disabled="controlesDesativados"
                                @click="aoVisualizarPedidoDeCompra(item)"
                            >

                                <v-icon dark>
                                    mdi-email-edit
                                </v-icon>
                            
                            </v-btn>

                        </template>

                        <span>Preencher o email do Pedido de Compra</span>

                    </v-tooltip>

                </template>

                <template v-slot:item.pdf="{ item }">

                    <v-tooltip bottom>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                class="c-visualizar-pedido mx-2"
                                fab
                                dark
                                small
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                                :disabled="controlesDesativados"
                                @click="downloadPDFDoPedido(item.id)"
                            >

                                <v-icon dark>
                                    mdi-download
                                </v-icon>
                            
                            </v-btn>

                        </template>

                        <span>Download PDF Pedido de Compra</span>

                    </v-tooltip>

                </template>

            </v-data-table>

        </v-card>

        <CriarEmail
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :pedidoDeCompra="pedidoDeCompraSelecionado"
            :controlesDesativados="controlesDesativados"
            :criandoEmail="criandoEmail"
            @update:criandoEmail="alteraCriandoEmail"
            @update:controlesDesativados="alteraControlesDesativados"
        ></CriarEmail>

    </main>

</template>

<style scoped>

.c-main{
    display: grid;
    gap: 15px;
}

.c-main--disabled{
    pointer-events: none;
    user-select: none; 
}

.c-main--disabled >>> .c-pedido__header{
    pointer-events: none;
    user-select: none; 
}

.c-pedido-holder{
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: 1fr auto; 
    grid-template-areas: 
    "titulo ."
    "buscas comprador";
    gap: 10px;
}

.c-pedido__title { 
    grid-area: titulo;
}

.c-pedido__buscas { 
    grid-area: buscas;
}

.c-busca__geral{
    grid-area: buscaGeral;
}

.c-comprador{
    grid-area: comprador;
    margin: 0 20px;
    min-height: 48px;
}

.c-comprador >>> .v-chip__content{
    margin: auto;
}

.c-pedido__tabela{
    display: grid;
    white-space: nowrap;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-visualizar-pedido{
    background: #1976d2 !important;
    border-color: #1976d2 !important;
}

@media (width <= 850px) {
    
    .c-pedido-holder{
        grid-template-columns: 1fr; 
        grid-template-rows: auto 1fr auto; 
        grid-template-areas:
            "titulo"
            "comprador"
            "buscas";
    }

    .c-comprador{
        margin: 0;
    }

    .c-pedido__buscas { 
        grid-template-rows: 1fr; 
        grid-template-areas: 
            "buscaGeral";
    }

}

</style>